import { render, staticRenderFns } from "./DiscoverAgendados.vue?vue&type=template&id=3f5f8838&scoped=true"
import script from "./DiscoverAgendados.vue?vue&type=script&lang=js"
export * from "./DiscoverAgendados.vue?vue&type=script&lang=js"
import style0 from "./DiscoverAgendados.vue?vue&type=style&index=0&id=3f5f8838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f8838",
  null
  
)

export default component.exports